jQuery(function ($) {
  "use strict";

  var init = [
    function () {
      if ($('.scroll-to-top').length) {
        let mybutton = document.getElementById("btn-back-to-top");

        // When the user scrolls down 150px from the top of the document, show the button
        window.onscroll = function () {
          scrollFunction();
        };

        function scrollFunction() {
          if (
            document.body.scrollTop > 150 ||
            document.documentElement.scrollTop > 150
          ) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

        function backToTop() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {}
    },
    function () {
      if ($('.main-navigation .main-navigation__search .site-search').length) {
        $(".main-navigation .main-navigation__search .site-search").click(function(){
          $(".main-navigation .main-navigation__search .search-form").toggle();
        });
      }
    },
    function () {
      $(document).ready(function() {
        var modalInner = $('.modal__inner');
        modalInner.each(function() {
          var content = $(this);
          $(this).remove();
          $('.entry-content').append(content);
        });
      });
    },
      function () {
      new WOW(
        {
          boxClass:     'wp-block-column',
          animateClass: 'fadeIn',
          offset:       0,
          mobile:       false,
          live:         true,
        }
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-cover__inner-container',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-bridges-hero-section__content',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-bridges-semi-cover__content',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      $(document).ready(function() {
        var headerHeight = $('.site-header').outerHeight();
        var body = $('body');
        var sticky = $('.site-header');
        var burger = $('#burger');
        var nav = $('.main-navigation__nav');

        // Function to handle sticky header
        function handleStickyHeader() {
          var scroll = $(window).scrollTop();

          if (scroll >= headerHeight + 10) {
            sticky.addClass('site-header--sticky');
            body.css('padding-top', headerHeight);
          } else {
            sticky.removeClass('site-header--sticky');
            body.css('padding-top', 0);
          }
        }

        // Initial call to handleStickyHeader to set the initial state
        handleStickyHeader();

        // Bind scroll event to handleStickyHeader
        $(window).scroll(handleStickyHeader);

        // Set initial top position for mobile navigation
        $('.site-header .main-navigation .main-navigation__nav').css('top', headerHeight);

        // Toggle mobile menu
        burger.on('click', function(e) {
          $(this).toggleClass('is-open');
          nav.toggleClass('is-open');
        });
      });
    },
    function () {
      $('.wp-block-cover.alignfull:not(.dark-theme-support), .wp-block-cover.alignwide:not(.dark-theme-support)').each(function() {
        var topSVG = $('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="cover-decoration cover-decoration__top" x="0px" y="0px" viewBox="0 0 1920 85.2" style="enable-background:new 0 0 1920 85.2;" xml:space="preserve"><path class="cover-decoration__figure" d="M0,0v85.2C311.7,29.9,632.5,1,960,1s648.3,28.9,960,84.2V0H0z"/></svg>');
        var bottomSVG = $('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="cover-decoration cover-decoration__bottom" x="0px" y="0px" viewBox="0 0 1920 85.2" style="enable-background:new 0 0 1920 85.2;" xml:space="preserve"><path class="cover-decoration__figure" d="M0,85.2V0c311.7,55.3,632.5,84.2,960,84.2S1608.3,55.3,1920,0v85.2H0z"/></svg>');
        $(this).prepend(topSVG);
        $(this).append(bottomSVG);
      });
    },
    function () {
      $('.is-style-rounded__animated').each(function() {
        var svg = $('<svg version="1.1" class="is-style-rounded__shape" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 702.6 702.6" style="enable-background:new 0 0 702.6 702.6;" xml:space="preserve"><style type="text/css">.is-style-rounded__shape-0{fill:#342E2A;}.is-style-rounded__shape-1{fill:#D30032;}</style><path class="is-style-rounded__shape-0" d="M351.3,702.6c-47.4,0-93.5-9.3-136.8-27.6c-41.8-17.7-79.4-43-111.7-75.3C70.6,567.4,45.3,529.8,27.6,488 C9.3,444.7,0,398.7,0,351.3c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9c0,188.3,153.2,341.4,341.4,341.4s341.4-153.2,341.4-341.4 c0-188.3-153.2-341.4-341.4-341.4c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9c47.4,0,93.5,9.3,136.8,27.6c41.8,17.7,79.4,43,111.7,75.3 s57.6,69.8,75.3,111.7c18.3,43.3,27.6,89.3,27.6,136.8s-9.3,93.5-27.6,136.8c-17.7,41.8-43,79.4-75.3,111.7s-69.8,57.6-111.7,75.3 C444.8,693.4,398.8,702.6,351.3,702.6z"/><path class="is-style-rounded__shape-1" d="M351.5,668.1c-4.8,0-9.7-0.1-14.5-0.3c-2.7-0.1-4.8-2.4-4.7-5.2c0.1-2.7,2.4-4.8,5.2-4.7 c81.8,3.7,160.2-24.8,220.8-80.1c60.5-55.3,95.9-130.9,99.6-212.8c3.7-81.9-24.8-160.3-80.1-220.8c-55.3-60.5-130.9-95.8-212.8-99.5 c-169-7.6-312.7,123.8-320.3,292.8c-0.1,2.7-2.4,4.9-5.2,4.7c-2.7-0.1-4.8-2.4-4.7-5.2c3.8-84.6,40.3-162.6,102.7-219.7 s143.4-86.4,228-82.6c84.6,3.8,162.6,40.3,219.7,102.7c57.1,62.4,86.4,143.4,82.6,228C663.8,450,627.3,528,564.9,585.1 C506,638.9,430.7,668.1,351.5,668.1z"/></svg>');
        $(this).prepend(svg);
      });
    },
    function () {
      $('.wp-block-bridges-tab-list').each(function() {
        $('.wp-block-bridges-tab-item:first-of-type > button').click();
      });
    },
  ];

  $.each(init, function (index, initFunction) {
    initFunction();
  });
});